import { create } from "zustand";

export interface ToastItem {
  id: number;
  message: string;
  type: "success" | "error" | "info";
}

let nextId = 1;

interface ToastState {
  toasts: ToastItem[];
  addToast: (message: string, type: ToastItem["type"]) => void;
  removeToast: (id: number) => void;
  toast: {
    success: (msg: string) => void;
    error: (msg: string) => void;
    info: (msg: string) => void;
  };
}

export const useToastStore = create<ToastState>((set) => {
  const addToast = (message: string, type: ToastItem["type"]) => {
    const id = nextId++;
    set((state) => ({ toasts: [...state.toasts, { id, message, type }] }));
  };

  return {
    toasts: [],
    addToast,
    removeToast: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
    toast: {
      success: (msg: string) => addToast(msg, "success"),
      error: (msg: string) => addToast(msg, "error"),
      info: (msg: string) => addToast(msg, "info"),
    },
  };
});
